import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.35 1.93a1.93 1.93 0 0 1 3.3 0l8.03 12.92c.85 1.36-.1 3.15-1.65 3.15H1.97C.41 18-.53 16.21.32 14.85L8.35 1.93Zm8.78 14.03a.5.5 0 0 0 .42-.77L10.42 3.72a.5.5 0 0 0-.84 0L2.45 15.2a.5.5 0 0 0 .42.77h14.26ZM10.01 12a.98.98 0 0 1-.98-.98l-.01-3.98a.98.98 0 1 1 1.97-.01v3.98c0 .55-.43.99-.98.99Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }, null, -1)
  ])))
}
export default { render: render }